import React, { FC } from 'react';
import ShopNavigationLegacy from '../../shared/navigation/ShopNavigationLegacy';
import { Route, Switch, useRouteMatch } from 'react-router';
import { LoanFormatNavigation } from '../../shared/navigation/LoanFormatNavigation';
import { LoanFormat } from '../../../models/LoanFormat';

type Props = {
    readonly isSticky: boolean;
};

const CatalogueNavigation: FC<Props> = ({ isSticky }) => {
    const { url } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${url}/eaudiobooks`}>
                <LoanFormatNavigation isSticky={isSticky} loanFormat={LoanFormat.eAudiobooks} />
            </Route>
            <Route path={`${url}/ebooks`}>
                <LoanFormatNavigation isSticky={isSticky} loanFormat={LoanFormat.eBooks} />
            </Route>
            <Route path={`${url}/epress`}>
                <LoanFormatNavigation ignoreNewReleases={true} isSticky={isSticky} loanFormat={LoanFormat.ePress} />
            </Route>
            <Route>
                <ShopNavigationLegacy isSticky={isSticky} />
            </Route>
        </Switch>
    );
};

CatalogueNavigation.displayName = 'CatalogueNavigation';

export default CatalogueNavigation;
